/**
 * Header Scroll Detection and Mobile Menu
 */

export function initHeaderScripts() {
    var headerContainer = document.querySelector('.header-container');

    function handleHeaderScroll() {
        if (!headerContainer) return;
        var scrollY = window.scrollY || window.pageYOffset;
        var isMobile = window.innerWidth < 1024;
        var scrollThreshold = isMobile ? 50 : 80;

        if (scrollY >= scrollThreshold) {
            headerContainer.classList.add('active');
        } else {
            headerContainer.classList.remove('active');
        }
    }

    handleHeaderScroll();

    var ticking = false;
    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                handleHeaderScroll();
                ticking = false;
            });
            ticking = true;
        }
    });

    window.addEventListener('resize', function() {
        handleHeaderScroll();
        if (window.innerWidth >= 1280 && isMenuOpen) {
            toggleMobileMenu();
        }
    });

    // Mobile Menu Toggle
    var mobileMenuButton = document.getElementById('mobile-menu-button');
    var mobileMenu = document.getElementById('mobile-menu');
    var hamburgerIcon = document.getElementById('hamburger-icon');
    var crossIcon = document.getElementById('cross-icon');
    var isMenuOpen = false;

    function toggleMobileMenu() {
        if (!mobileMenu) return;

        if (isMenuOpen) {
            mobileMenu.style.maxHeight = '0';
            isMenuOpen = false;
            document.body.classList.remove('mobile-nav-open');
            if (hamburgerIcon) {
                hamburgerIcon.classList.remove('opacity-0');
                hamburgerIcon.classList.add('opacity-100');
            }
            if (crossIcon) {
                crossIcon.classList.remove('opacity-100');
                crossIcon.classList.add('opacity-0');
            }
        } else {
            mobileMenu.style.maxHeight = mobileMenu.scrollHeight + 'px';
            isMenuOpen = true;
            document.body.classList.add('mobile-nav-open');
            if (hamburgerIcon) {
                hamburgerIcon.classList.remove('opacity-100');
                hamburgerIcon.classList.add('opacity-0');
            }
            if (crossIcon) {
                crossIcon.classList.remove('opacity-0');
                crossIcon.classList.add('opacity-100');
            }
        }
    }

    function refreshMobileMenuHeight() {
        if (isMenuOpen && mobileMenu) {
            mobileMenu.style.maxHeight = mobileMenu.scrollHeight + 'px';
        }
    }

    window.toggleMobileSubmenu = function(menuId, arrowId) {
        var submenu = document.getElementById(menuId);
        var arrow = document.getElementById(arrowId);
        if (!submenu) return;

        var button = arrow ? arrow.closest('button') : null;
        var isHidden = submenu.classList.contains('hidden');

        if (isHidden) {
            submenu.classList.remove('hidden');
            if (arrow) arrow.classList.add('rotate-180');
            if (button) button.setAttribute('aria-expanded', 'true');
        } else {
            submenu.classList.add('hidden');
            if (arrow) arrow.classList.remove('rotate-180');
            if (button) button.setAttribute('aria-expanded', 'false');
        }

        refreshMobileMenuHeight();
    };

    /**
     * Nested mobile accordion: category → inner tab → links
     */
    window.toggleMobileAccordion = function(panelId, iconId) {
        var panel = document.getElementById(panelId);
        var icon = document.getElementById(iconId);
        if (!panel) return;

        var button = icon ? icon.closest('button') : panel.previousElementSibling;
        var isOpen = !panel.classList.contains('hidden');

        // Close sibling panels at the same nesting level
        var parent = panel.parentElement ? panel.parentElement.parentElement : null;
        if (parent) {
            parent.querySelectorAll(':scope > .mobile-accordion-item > .mobile-accordion-panel').forEach(function(sibling) {
                if (sibling === panel) return;
                sibling.classList.add('hidden');
                var siblingBtn = sibling.previousElementSibling;
                if (siblingBtn) {
                    siblingBtn.setAttribute('aria-expanded', 'false');
                    siblingBtn.classList.remove('text-primary');
                    siblingBtn.classList.add('text-white');
                    var siblingIcon = siblingBtn.querySelector('.mobile-accordion-icon');
                    if (siblingIcon) siblingIcon.textContent = '+';
                }
            });
        }

        if (isOpen) {
            panel.classList.add('hidden');
            if (icon) icon.textContent = '+';
            if (button) {
                button.setAttribute('aria-expanded', 'false');
                button.classList.remove('text-primary');
                button.classList.add('text-white');
            }
        } else {
            panel.classList.remove('hidden');
            if (icon) icon.textContent = '\u2212';
            if (button) {
                button.setAttribute('aria-expanded', 'true');
                button.classList.remove('text-white');
                button.classList.add('text-primary');
            }
        }

        refreshMobileMenuHeight();
    };

    // Backwards-compatible alias
    window.toggleMobileServicesCategory = window.toggleMobileAccordion;

    if (mobileMenuButton) {
        mobileMenuButton.addEventListener('click', toggleMobileMenu);
    }

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && isMenuOpen) toggleMobileMenu();
    });

    document.addEventListener('click', function(e) {
        if (isMenuOpen && mobileMenu && !mobileMenu.contains(e.target) && mobileMenuButton && !mobileMenuButton.contains(e.target)) {
            toggleMobileMenu();
        }
    });

    // ============================================
    // MEGA MENU - Desktop hover interactions
    // ============================================
    initMegaMenu();
    initServicesMenuTabs();
    initPortfolioMenuTabs();
    initResourcesMenuTabs();
    initAboutMenuTabs();
}

/**
 * Mega Menu - Desktop hover interactions
 * Handles showing/hiding mega menu panels on hover
 */
function initMegaMenu() {
    const menuTriggers = document.querySelectorAll('[data-mega-menu]');
    const megaMenuPanels = document.querySelectorAll('.mega-menu-panel');
    
    if (menuTriggers.length === 0 || megaMenuPanels.length === 0) return;
    
    let hideTimeout = null;
    const openLinkClasses = ['text-primary', 'border-b-primary', 'is-mega-open'];
    
    function clearOpenStates() {
        menuTriggers.forEach(trigger => {
            const link = trigger.querySelector('a');
            const svg = trigger.querySelector('.mega-menu-caret, svg');
            if (link) link.classList.remove(...openLinkClasses);
            if (svg) svg.classList.remove('rotate-180');
        });
    }
    
    function showMegaMenu(menuId) {
        if (hideTimeout) {
            clearTimeout(hideTimeout);
            hideTimeout = null;
        }
        
        megaMenuPanels.forEach(panel => {
            panel.classList.add('invisible', 'opacity-0');
            panel.classList.remove('visible', 'opacity-100');
        });
        
        clearOpenStates();
        
        const targetMenu = document.getElementById('mega-menu-' + menuId);
        if (targetMenu) {
            targetMenu.classList.remove('invisible', 'opacity-0');
            targetMenu.classList.add('visible', 'opacity-100');
            
            const trigger = document.querySelector('[data-mega-menu="' + menuId + '"]');
            if (trigger) {
                const link = trigger.querySelector('a');
                const svg = trigger.querySelector('.mega-menu-caret, svg');
                if (link) link.classList.add(...openLinkClasses);
                if (svg) svg.classList.add('rotate-180');
            }
        }
    }
    
    function hideMegaMenus() {
        hideTimeout = setTimeout(function() {
            megaMenuPanels.forEach(panel => {
                panel.classList.add('invisible', 'opacity-0');
                panel.classList.remove('visible', 'opacity-100');
            });
            clearOpenStates();
        }, 150);
    }
    
    menuTriggers.forEach(trigger => {
        trigger.addEventListener('mouseenter', function() {
            showMegaMenu(this.getAttribute('data-mega-menu'));
        });
        trigger.addEventListener('mouseleave', hideMegaMenus);
    });
    
    megaMenuPanels.forEach(panel => {
        panel.addEventListener('mouseenter', function() {
            if (hideTimeout) {
                clearTimeout(hideTimeout);
                hideTimeout = null;
            }
            // Keep matching trigger highlighted while hovering the panel
            const menuId = panel.getAttribute('data-menu');
            if (menuId) {
                clearOpenStates();
                const trigger = document.querySelector('[data-mega-menu="' + menuId + '"]');
                if (trigger) {
                    const link = trigger.querySelector('a');
                    const svg = trigger.querySelector('.mega-menu-caret, svg');
                    if (link) link.classList.add(...openLinkClasses);
                    if (svg) svg.classList.add('rotate-180');
                }
            }
        });
        panel.addEventListener('mouseleave', hideMegaMenus);
    });
}

/**
 * Shared sidebar tab helper
 */
function initSidebarTabs(panelId, tabSelector, panelSelector, activeClasses, inactiveClasses) {
    const panel = document.getElementById(panelId);
    if (!panel) return;

    const tabs = panel.querySelectorAll(tabSelector);
    const panels = panel.querySelectorAll(panelSelector);
    if (tabs.length === 0) return;

    function activateTab(tab) {
        const targetId = tab.getAttribute('data-tab');

        tabs.forEach(t => {
            activeClasses.forEach(cls => t.classList.remove(cls));
            inactiveClasses.forEach(cls => t.classList.add(cls));
        });
        inactiveClasses.forEach(cls => tab.classList.remove(cls));
        activeClasses.forEach(cls => tab.classList.add(cls));

        panels.forEach(p => p.classList.add('hidden'));
        const target = document.getElementById(targetId);
        if (target) target.classList.remove('hidden');
    }

    tabs.forEach(tab => {
        tab.addEventListener('mouseenter', () => activateTab(tab));
        tab.addEventListener('click', (e) => {
            if (e.target.closest('a')) return;
            e.preventDefault();
            activateTab(tab);
        });
    });
}

/**
 * Services Mega Menu - Category tab switching + inner tabs
 */
function initServicesMenuTabs() {
    const panel = document.getElementById('mega-menu-services');
    if (!panel) return;

    const tabs = panel.querySelectorAll('.services-tab');
    const panels = panel.querySelectorAll('.services-tab-panel');
    if (tabs.length === 0) return;

    const activeClasses = ['border-l-primary', 'bg-[#FFF3E8]', 'text-primary'];
    const inactiveClasses = ['border-l-transparent', 'text-[#002559]'];

    const innerActive = ['border-b-primary', 'text-primary'];
    const innerInactive = ['border-b-transparent', 'text-[#002559]'];

    function activateInnerTab(innerTab) {
        const categoryIndex = innerTab.getAttribute('data-category');
        const targetId = innerTab.getAttribute('data-inner');
        const categoryPanel = document.getElementById('services-tab-' + categoryIndex);
        if (!categoryPanel) return;

        const innerTabs = categoryPanel.querySelectorAll('.services-inner-tab');
        const innerPanels = categoryPanel.querySelectorAll('.services-inner-panel');

        innerTabs.forEach(t => {
            innerActive.forEach(cls => t.classList.remove(cls));
            innerInactive.forEach(cls => t.classList.add(cls));
        });
        innerInactive.forEach(cls => innerTab.classList.remove(cls));
        innerActive.forEach(cls => innerTab.classList.add(cls));

        innerPanels.forEach(p => p.classList.add('hidden'));
        const target = document.getElementById(targetId);
        if (target) target.classList.remove('hidden');
    }

    function activateTab(tab) {
        const targetId = tab.getAttribute('data-tab');

        tabs.forEach(t => {
            activeClasses.forEach(cls => t.classList.remove(cls));
            inactiveClasses.forEach(cls => t.classList.add(cls));
        });
        inactiveClasses.forEach(cls => tab.classList.remove(cls));
        activeClasses.forEach(cls => tab.classList.add(cls));

        panels.forEach(p => p.classList.add('hidden'));
        const target = document.getElementById(targetId);
        if (target) target.classList.remove('hidden');
    }

    tabs.forEach(tab => {
        tab.addEventListener('mouseenter', () => activateTab(tab));
        tab.addEventListener('click', (e) => {
            if (e.target.closest('a')) return;
            e.preventDefault();
            activateTab(tab);
        });
    });

    panel.querySelectorAll('.services-inner-tab').forEach(innerTab => {
        innerTab.addEventListener('mouseenter', () => activateInnerTab(innerTab));
        innerTab.addEventListener('click', (e) => {
            if (e.target.closest('a')) return;
            e.preventDefault();
            activateInnerTab(innerTab);
        });
    });
}

/**
 * Resources Mega Menu - Blog / Testimonials tabs
 */
function initResourcesMenuTabs() {
    initSidebarTabs(
        'mega-menu-resources',
        '.resources-tab',
        '.resources-tab-panel',
        ['border-l-primary', 'bg-[#FFF3E8]', 'text-primary'],
        ['border-l-transparent', 'text-[#606060]']
    );
}

/**
 * About Mega Menu - Team / Partnership tabs
 */
function initAboutMenuTabs() {
    initSidebarTabs(
        'mega-menu-about',
        '.about-tab',
        '.about-tab-panel',
        ['border-l-primary', 'bg-[#FFF3E8]', 'text-primary'],
        ['border-l-transparent', 'text-[#606060]']
    );
}

/**
 * Portfolio Mega Menu - Industry + service filter tabs
 */
function initPortfolioMenuTabs() {
    const panel = document.getElementById('mega-menu-portfolio');
    if (!panel) return;

    const industryTabs = panel.querySelectorAll('.portfolio-industry-tab');
    const industryPanels = panel.querySelectorAll('.portfolio-industry-panel');
    if (industryTabs.length === 0) return;

    const industryActive = ['border-l-primary', 'bg-[#FFF3E8]', 'text-primary'];
    const industryInactive = ['border-l-transparent', 'text-[#002559]'];
    const serviceActive = ['border-primary', 'text-primary', 'bg-[#FFF3E8]'];
    const serviceInactive = ['border-[#002559]/30', 'text-[#002559]'];

    function activateIndustry(tab) {
        const targetId = tab.getAttribute('data-industry');

        industryTabs.forEach(t => {
            industryActive.forEach(cls => t.classList.remove(cls));
            industryInactive.forEach(cls => t.classList.add(cls));
        });
        industryInactive.forEach(cls => tab.classList.remove(cls));
        industryActive.forEach(cls => tab.classList.add(cls));

        industryPanels.forEach(p => p.classList.add('hidden'));
        const target = document.getElementById(targetId);
        if (target) target.classList.remove('hidden');
    }

    function activateService(tab) {
        const industryIndex = tab.getAttribute('data-industry');
        const targetId = tab.getAttribute('data-service');
        const industryPanel = document.getElementById('portfolio-industry-' + industryIndex);
        if (!industryPanel) return;

        const serviceTabs = industryPanel.querySelectorAll('.portfolio-service-tab');
        const servicePanels = industryPanel.querySelectorAll('.portfolio-service-panel');

        serviceTabs.forEach(t => {
            serviceActive.forEach(cls => t.classList.remove(cls));
            serviceInactive.forEach(cls => t.classList.add(cls));
            t.classList.add('border');
        });
        serviceInactive.forEach(cls => tab.classList.remove(cls));
        serviceActive.forEach(cls => tab.classList.add(cls));

        servicePanels.forEach(p => p.classList.add('hidden'));
        const target = document.getElementById(targetId);
        if (target) target.classList.remove('hidden');
    }

    industryTabs.forEach(tab => {
        tab.addEventListener('mouseenter', () => activateIndustry(tab));
        tab.addEventListener('click', (e) => {
            if (e.target.closest('a')) return;
            e.preventDefault();
            activateIndustry(tab);
        });
    });

    panel.querySelectorAll('.portfolio-service-tab').forEach(tab => {
        tab.addEventListener('mouseenter', () => activateService(tab));
        tab.addEventListener('click', (e) => {
            if (e.target.closest('a')) return;
            e.preventDefault();
            activateService(tab);
        });
    });
}
